export default "__VITE_ASSET__BpdW4Sxv__"